import React from 'react';
import EditorDelete from '@wix/da-ds/pkg/Icons/24x24/EditorDelete';
import { TOOLTIP_HOVER_DELAY } from '../../../../constants';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../../../../components/menus/_partials/EditorIconButton';
const Delete = ({ editor })=>{
    const { t } = useTranslation('editor');
    return /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:gif:delete",
        icon: EditorDelete,
        onClick: ()=>editor.chain().focus().daDeviationDelete().run(),
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY,
        tooltipText: t('ext.gif.button.delete'),
        "aria-label": t('ext.gif.button.delete')
    });
};
Delete.displayName = 'Delete';
export default Delete;

//# sourceMappingURL=Delete.js.map